exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3IPRQ{color:#fff;background-color:#e4002b;border-color:#e4002b;cursor:pointer;font-family:Roboto\\, Medium;width:190px}._3LosR{fill:#f81}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_3IPRQ",
	"icono": "_3LosR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Login/ModalAltaPendiente/ModalAltaPendiente.css
// module id = 1024
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13